module.exports = __webpack_public_path__ + "common/gh-icon-cart-ba0c7334ea534ae43257b03c9ae045a9.svg";